import {
    LuFileText,
    LuListChecks,
    LuLogIn,
    LuPhoneOff,
    LuSmartphone,
    LuTarget,
    LuUserX,
    LuZap,
} from 'react-icons/lu';
import { Button } from '../../components';
import { V2_TOKENS } from '../../tokens';
import { showConfirm } from 'presentation/redux/features/app/appSlice';
import { useAppSelector } from 'presentation/redux/hooks';
import { AUTH_ROUTES, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import type { AssessmentOption } from '../index';
import styles from '../styles.module.scss';

const ICON_MAP: Record<string, React.ComponentType<{ size?: number; color?: string }>> = {
    smartphone: LuSmartphone,
    'user-x': LuUserX,
    'phone-off': LuPhoneOff,
    target: LuTarget,
    'list-checks': LuListChecks,
    'log-in': LuLogIn,
};

export const AssessmentCard = (props: AssessmentOption) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userSlice = useAppSelector((state) => state.user);

    const handleClick = () => {
        if (props.requiresLogin && !userSlice?.isSignedIn) {
            const confirmProps = {
                message: '以降のステップには\nログインが必要です。',
                okText: 'ログイン・アカウント作成へ',
                cancelText: 'いいえ',
                type: 'info',
                onOk: () => navigate(`${AUTH_ROUTES.PATH}/${AUTH_ROUTES.SUB.CU_001_00}`),
            };
            dispatch(showConfirm(confirmProps));
        } else {
            navigate(`${PRIVATE_ROUTES.PATH}/${props.redirect}`);
        }
    };

    const isEasy = props.type === 'easy';

    return (
        <div
            className={`${styles.card} ${isEasy ? styles.cardEasy : styles.cardDetail}`}
            onClick={handleClick}
        >
            <div className={styles.cardTopRow}>
                <div
                    className={`${styles.cardIconCircle} ${isEasy ? styles.cardIconCircleEasy : styles.cardIconCircleDetail}`}
                >
                    {isEasy ? (
                        <LuZap size={24} color={V2_TOKENS.color.white} />
                    ) : (
                        <LuFileText size={22} color={V2_TOKENS.color.textSecondary} />
                    )}
                </div>
                <div className={styles.cardTitleGroup}>
                    {props.badge && <span className={styles.cardBadge}>{props.badge}</span>}
                    {props.label && <span className={styles.cardLabel}>{props.label}</span>}
                    <h3 className={styles.cardTitle}>{props.title}</h3>
                </div>
            </div>

            <p className={styles.cardDescription}>{props.description}</p>

            <div className={styles.cardFeatures}>
                {props.features.map((feature) => {
                    const FeatureIcon = ICON_MAP[feature.icon];
                    const iconColor =
                        feature.colored !== false
                            ? V2_TOKENS.color.primary
                            : V2_TOKENS.color.textSecondary;
                    return (
                        <div key={feature.text} className={styles.featureItem}>
                            <span className={styles.featureIcon}>
                                {FeatureIcon ? <FeatureIcon size={22} color={iconColor} /> : '•'}
                            </span>
                            <span className={styles.featureText}>{feature.text}</span>
                        </div>
                    );
                })}
            </div>

            <Button variant={isEasy ? 'primary' : 'secondary'} showArrow onClick={handleClick}>
                {props.ctaText}
            </Button>
        </div>
    );
};
